// Text carried over unchanged from the v1 site (FayshaaWeb frontend/src/pages/PrivacyPolicy.jsx).
export const LAST_UPDATED = 'April 30, 2026';

export default function PrivacyBody() {
  return (
    <>
      <div>
        <p>
          At Faysha - Property by Result ("we," "our," or "us"), we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <a href="https://www.fayshaa.com">www.fayshaa.com</a> and use our services.
        </p>
        <p>
          Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site or use our services.
        </p>
      </div>

      <div>
        <h2>
          1. Information We Collect
        </h2>

        <h3>
          1.1 Personal Information
        </h3>
        <p>
          We may collect personal information that you voluntarily provide to us when you:
        </p>
        <ul>
          <li>Make a booking or reservation</li>
          <li>Create an account</li>
          <li>Contact us with inquiries</li>
          <li>Subscribe to our newsletter</li>
          <li>Apply for a job</li>
          <li>Provide feedback</li>
        </ul>
        <p>
          This information may include:
        </p>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Mailing address</li>
          <li>Payment information (processed securely through Stripe)</li>
          <li>Government-issued ID (for booking verification)</li>
          <li>Employment history and qualifications (for job applications)</li>
        </ul>

        <h3>
          1.2 Automatically Collected Information
        </h3>
        <p>
          When you visit our website, we automatically collect certain information about your device, including:
        </p>
        <ul>
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Device type and operating system</li>
          <li>Referring website</li>
          <li>Pages visited and time spent on pages</li>
          <li>Date and time of visits</li>
        </ul>
      </div>

      <div>
        <h2>
          2. How We Use Your Information
        </h2>
        <p>
          We use the information we collect for the following purposes:
        </p>
        <ul>
          <li>To process and manage your bookings and reservations</li>
          <li>To communicate with you about your bookings, including sending confirmations and digital access codes</li>
          <li>To process payments securely</li>
          <li>To respond to your inquiries and provide customer support</li>
          <li>To send you marketing communications (with your consent)</li>
          <li>To improve our website and services</li>
          <li>To analyze usage patterns and optimize user experience</li>
          <li>To process job applications</li>
          <li>To comply with legal obligations</li>
          <li>To prevent fraud and enhance security</li>
        </ul>
      </div>

      <div>
        <h2>
          3. Information Sharing and Disclosure
        </h2>
        <p>
          We do not sell, trade, or rent your personal information to third parties. We may share your information in the following circumstances:
        </p>

        <h3>
          3.1 Service Providers
        </h3>
        <p>
          We may share your information with third-party service providers who assist us in operating our website and providing our services, including:
        </p>
        <ul>
          <li>Payment processors (Stripe)</li>
          <li>Email service providers</li>
          <li>Cloud hosting services</li>
          <li>Analytics providers</li>
        </ul>

        <h3>
          3.2 Legal Requirements
        </h3>
        <p>
          We may disclose your information if required to do so by law or in response to valid requests by public authorities (e.g., court orders, government agencies).
        </p>
      </div>

      <div>
        <h2>
          4. Data Security
        </h2>
        <p>
          We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:
        </p>
        <ul>
          <li>SSL/TLS encryption for data transmission</li>
          <li>Secure payment processing through PCI-compliant providers</li>
          <li>Regular security assessments and updates</li>
          <li>Access controls and authentication</li>
          <li>Employee training on data protection</li>
        </ul>
        <p>
          However, no method of transmission over the Internet or electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee absolute security.
        </p>
      </div>

      <div>
        <h2>
          5. Your Privacy Rights
        </h2>
        <p>
          You have the following rights regarding your personal information:
        </p>
        <ul>
          <li><strong>Access:</strong> Request copies of your personal information</li>
          <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
          <li><strong>Deletion:</strong> Request deletion of your personal information</li>
          <li><strong>Objection:</strong> Object to our processing of your personal information</li>
          <li><strong>Restriction:</strong> Request restriction of processing of your personal information</li>
          <li><strong>Data Portability:</strong> Request transfer of your information to another service</li>
          <li><strong>Withdraw Consent:</strong> Withdraw your consent at any time</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at <a href="mailto:info@fayshaa.com">info@fayshaa.com</a>.
        </p>
      </div>

      <div>
        <h2>
          6. Cookies and Tracking Technologies
        </h2>
        <p>
          We use cookies and similar tracking technologies to track activity on our website and store certain information. Cookies are files with small amounts of data that are sent to your browser from a website and stored on your device.
        </p>
        <p>
          You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
        </p>
      </div>

      <div>
        <h2>
          7. Third-Party Links
        </h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to read the privacy policies of any third-party sites you visit.
        </p>
      </div>

      <div>
        <h2>
          8. Children's Privacy
        </h2>
        <p>
          Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us, and we will take steps to delete such information.
        </p>
      </div>

      <div>
        <h2>
          9. International Data Transfers
        </h2>
        <p>
          Your information may be transferred to and maintained on computers located outside of Cameroon, where data protection laws may differ. By using our services, you consent to the transfer of your information to our facilities and service providers.
        </p>
      </div>

      <div>
        <h2>
          10. Data Retention
        </h2>
        <p>
          We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it.
        </p>
      </div>

      <div>
        <h2>
          11. Push Notifications
        </h2>
        <p>
          We may send you push notifications regarding your bookings, special offers, and important updates. You can opt-out of receiving push notifications by adjusting your device settings or through the notification preferences in your account.
        </p>
      </div>

      <div>
        <h2>
          12. Changes to This Privacy Policy
        </h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last updated" date. We encourage you to review this Privacy Policy periodically.
        </p>
      </div>

      <div>
        <h2>
          13. Contact Us
        </h2>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
        </p>
        <div>
          <p><strong>Faysha - Property by Result</strong></p>
          <p>Email: <a href="mailto:info@fayshaa.com">info@fayshaa.com</a></p>
          <p>Website: <a href="https://www.fayshaa.com">www.fayshaa.com</a></p>
          <p>Location: Cameroon</p>
        </div>
      </div>

      <div>
        <p>
          By using our website and services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
        </p>
      </div>
    </>
  );
}
